import React from "react";
import MessageBanner from "components/design-system/message-banner";
import NotifyBell from "images/notify_bell.svg";

const NotifyMeBanner = () => {
  const messageContent = (
    <div className="text-start">
      You will be notified when this item is available in your size(s).{" "}
      <a className="underline" href="/user/notifications">
        Manage Notifications
      </a>
    </div>
  );

  return (
    <MessageBanner
      additionalClasses={{
        containerOverrides: "rounded-none",
      }}
      icon={<NotifyBell />}
      messageContent={messageContent}
    />
  );
};

export default NotifyMeBanner;
